import "./footer.css";

function FooterSection() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__slogan">Keeping you high and dry since 2005</p>
        <p className="site-footer__text">&copy; ClimbingWeather.com. All rights reserved.</p>
        <p className="site-footer__text">Twitter: @climbingweather</p>
      </div>
    </footer>
  );
}

export default FooterSection;
